import { render, staticRenderFns } from "./WebScrapStore.vue?vue&type=template&id=5c800a9a&scoped=true"
import script from "./WebScrapStore.vue?vue&type=script&lang=js"
export * from "./WebScrapStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c800a9a",
  null
  
)

export default component.exports